import { useMutation } from '@tanstack/react-query';

import { getLanguageCode } from '../../../lib/context';
import { downloadFromUrl } from '../../../lib/download';
import { formatUtcOffset } from '../../../lib/timezone';
import { getCertPdfUrl, getReportPdfUrl } from './downloadsApi';

interface PdfVariables {
    deviceId: string;
    language: string;
    fileName: string;
}

const savePdf = async (res: any, fileName: string) => {
    if (res?.status !== 'success' || !res.url) {
        throw new Error(res?.message ?? 'no download url');
    }
    await downloadFromUrl(res.url, fileName);
};

/** Generates the device's data report PDF and saves it. */
export const useDownloadReportPdf = () =>
    useMutation({
        mutationFn: async ({ deviceId, language, fileName }: PdfVariables) =>
            savePdf(await getReportPdfUrl(deviceId, 0, formatUtcOffset(), getLanguageCode(language), true), fileName),
    });

/** Generates the device's calibration certificate PDF and saves it. */
export const useDownloadCertPdf = () =>
    useMutation({
        mutationFn: async ({ deviceId, language, fileName }: PdfVariables) =>
            savePdf(await getCertPdfUrl(deviceId, formatUtcOffset(), getLanguageCode(language), true), fileName),
    });
